<!-- Estilos: src/assets/styles/components/_liga-ui.scss (sistema .lx-*) y _liga-b.scss (.lxb-*). -->
<section class="lx-pagina" lang="es" [class.lx-pagina--con-cta]="!terminado">
  <header class="lx-hero">
    <div class="lx-hero__cabeza">
      <span class="lx-hero__icono" [class.lx-hero__icono--verde]="terminado" [class.lx-hero__icono--navy]="!terminado && !data.value" aria-hidden="true">
        <fa-icon [icon]="terminado ? iconos.listo : (data.value ? iconos.externo : iconos.reloj)"></fa-icon>
      </span>
      <div class="lx-hero__textos">
        <span class="lx-hero__eyebrow">{{terminado ? 'Lo estamos revisando' : 'Se completa en otra página'}}</span>
        <h2 class="lx-hero__titulo">{{titulo}}</h2>
        <p class="lx-hero__subtitulo" *ngIf="!terminado">{{subtitulo}}</p>
        <span class="lx-chip" *ngIf="terminado" [ngClass]="estados.revision.chip">
          <fa-icon *ngIf="estados.revision.icono as icono" [icon]="icono" aria-hidden="true"></fa-icon>{{estados.revision.texto}}
        </span>
        <ng-container *ngIf="!terminado && !startedProcess">
          <span class="lx-chip" *ngIf="data.comment; else sinComentario" [ngClass]="estados.corrige.chip">
            <fa-icon *ngIf="estados.corrige.icono as icono" [icon]="icono" aria-hidden="true"></fa-icon>{{estados.corrige.texto}}
          </span>
          <ng-template #sinComentario>
            <span class="lx-chip lx-chip--aviso" *ngIf="!data.value">
              <fa-icon [icon]="iconos.reloj" aria-hidden="true"></fa-icon>Liga en preparación
            </span>
          </ng-template>
        </ng-container>
      </div>
    </div>
  </header>

  <!-- Terminó: lo revisamos y regresa solo a la lista -->
  <div class="lx-celebracion" *ngIf="terminado; else enCurso" role="status">
    <div class="lx-celebracion__check">
      <svg class="lx-check" viewBox="0 0 52 52" aria-hidden="true">
        <circle class="lx-check__circulo" cx="26" cy="26" r="25"></circle>
        <path class="lx-check__trazo" d="M15 27.5l7 7 15-16"></path>
      </svg>
    </div>
    <h3 class="lx-celebracion__titulo">¡Gracias! Lo vamos a revisar</h3>
    <p class="lx-celebracion__msg">Revisaremos que hayas terminado y te avisaremos si falta algo.</p>
    <button type="button" class="lx-btn lx-btn--primario" (click)="continuar()"><span>Continuar</span></button>
    <p class="lx-celebracion__nota">Te regresamos a tus pasos en unos segundos.</p>
  </div>

  <ng-template #enCurso>
    <!-- Rechazo del paso: con el motivo -->
    <div class="lx-alerta lx-alerta--error" *ngIf="data.comment && !startedProcess">
      <span class="lx-alerta__icono" aria-hidden="true"><fa-icon [icon]="iconos.error"></fa-icon></span>
      <div class="lx-alerta__cuerpo">
        <p class="lx-alerta__titulo">Necesitamos que lo hagas de nuevo</p>
        <p class="lx-alerta__texto">Motivo: <strong>{{data.comment}}</strong></p>
      </div>
    </div>

    <!-- No se pudo confirmar: en línea -->
    <div class="lx-alerta lx-alerta--error lxb-aviso-error lxb-enfocable" role="alert" tabindex="-1" *ngIf="aviso as a">
      <span class="lx-alerta__icono" aria-hidden="true"><fa-icon [icon]="iconos.error"></fa-icon></span>
      <div class="lx-alerta__cuerpo">
        <p class="lx-alerta__titulo">{{a.titulo}}</p>
        <p class="lx-alerta__texto">{{a.texto}}</p>
      </div>
      <button type="button" class="lx-alerta__cerrar" aria-label="Cerrar aviso" (click)="cerrarAviso()">
        <fa-icon [icon]="iconos.cerrar"></fa-icon>
      </button>
    </div>

    <ng-container *ngIf="startedProcess; else antesDeEmpezar">
      <!-- Ya abrió la página: ¿terminó? -->
      <section class="lx-tarjeta lx-tarjeta--resaltada lxb-estado" aria-labelledby="lxb-externo-pregunta">
        <div class="lx-halo" aria-hidden="true"><fa-icon [icon]="iconos.externo"></fa-icon></div>
        <h3 class="lxb-estado__titulo" id="lxb-externo-pregunta">¿Ya terminaste en la otra página?</h3>
        <p class="lxb-estado__texto">Cuando completes todo allá, toca <strong>«Ya terminé el proceso»</strong> para que lo revisemos.</p>
        <div class="lx-acciones">
          <a class="lx-btn lx-btn--secundario" [href]="getLink" target="_blank" rel="noopener" (click)="open()">
            <fa-icon [icon]="iconos.externo" aria-hidden="true"></fa-icon><span>Volver a abrir la página</span>
          </a>
        </div>
      </section>
    </ng-container>

    <ng-template #antesDeEmpezar>
      <ng-container *ngIf="data.value; else sinLiga">
        <section class="lx-tarjeta" aria-labelledby="lxb-externo-como">
          <div class="lx-tarjeta__cabeza">
            <h3 class="lx-tarjeta__titulo" id="lxb-externo-como">Así funciona</h3>
          </div>
          <ol class="lx-lista lx-lista--numerada">
            <li>Toca <strong>«Abrir página para empezar»</strong>; se abre en otra pestaña.</li>
            <li>Completa el proceso en esa página.</li>
            <li>Regresa aquí y toca <strong>«Ya terminé el proceso»</strong> para que lo revisemos.</li>
          </ol>
          <p class="lxb-destino" *ngIf="dominio">
            <fa-icon [icon]="iconos.sitio" aria-hidden="true"></fa-icon>
            <span>Te llevamos a <strong>{{dominio}}</strong></span>
          </p>
        </section>
      </ng-container>

      <!-- El asesor aún no genera la liga -->
      <ng-template #sinLiga>
        <section class="lx-tarjeta lxb-estado" aria-labelledby="lxb-externo-espera">
          <div class="lx-halo" aria-hidden="true"><fa-icon [icon]="iconos.reloj"></fa-icon></div>
          <h3 class="lxb-estado__titulo" id="lxb-externo-espera">Tu asesor está preparando tu liga</h3>
          <p class="lxb-estado__texto">Cuando esté lista te avisaremos para que continúes. Por ahora no tienes que hacer nada.</p>
        </section>
      </ng-template>
    </ng-template>

    <!-- Lo que dice la configuración del paso (ya en curso, solo el texto) -->
    <article class="lx-tarjeta lx-pila" *ngIf="settings.description || (settings.img && !imagenFallo && !startedProcess)">
      <img class="lxb-ilustracion" *ngIf="settings.img && !imagenFallo && !startedProcess" [src]="settings.img" alt="" loading="lazy" (error)="imagenFallo = true">
      <p class="lxb-texto" *ngIf="settings.description">{{settings.description}}</p>
    </article>
  </ng-template>

  <p class="lx-seguro lx-seguro--ayuda">
    <span class="lx-seguro__icono" aria-hidden="true"><fa-icon [icon]="iconos.ayuda"></fa-icon></span>
    <span *ngIf="data.value && !terminado; else ayudaGeneral">Esta pestaña se queda abierta para que regreses cuando termines. ¿Dudas? Tu asesor te puede ayudar.</span>
    <ng-template #ayudaGeneral><span>¿Tienes dudas sobre este paso? Tu asesor te puede ayudar.</span></ng-template>
  </p>
</section>

<!-- Botón principal fijo abajo (hermano de la página: nada animado por encima) -->
<div class="lx-cta-fijo" *ngIf="!terminado">
  <ng-container *ngIf="startedProcess; else ctaInicio">
    <button type="button" class="lx-btn lx-btn--primario" [class.is-cargando]="enviando" [attr.aria-busy]="enviando" (click)="validateExternalLink()">
      <span class="lx-spinner" *ngIf="enviando" aria-hidden="true"></span>
      <span>{{enviando ? 'Confirmando…' : 'Ya terminé el proceso'}}</span>
    </button>
  </ng-container>
  <ng-template #ctaInicio>
    <a class="lx-btn lx-btn--primario" *ngIf="data.value; else ctaSinLiga" [href]="getLink" target="_blank" rel="noopener" (click)="open()">
      <span>Abrir página para empezar</span><fa-icon [icon]="iconos.externo" aria-hidden="true"></fa-icon>
    </a>
    <ng-template #ctaSinLiga>
      <button type="button" class="lx-btn lx-btn--primario" (click)="entendido()"><span>Entendido, volver a mis pasos</span></button>
    </ng-template>
  </ng-template>
  <p class="lx-cta-fijo__nota" *ngIf="!startedProcess && data.value">
    <fa-icon [icon]="iconos.externo" aria-hidden="true"></fa-icon>Se abre en otra pestaña
  </p>
</div>
